import auth from '../../../services/auth'
import sales from '../../../services/sales'
import { cents } from '../../../filters/number'
import axios from 'axios';
import validaRecarga from '../../../validators/recarga-minima'

export default {
  data() {
    return {
      user: auth.currentUser,
      rechargeValue: undefined,
      rate: 0,
      credit: 0,
      loadingRates: Promise.resolve(true),
      loading: Promise.resolve(true),
      source: undefined,
      rechargeUnit: undefined,
      minValue: undefined,
      qtdFix: 4,
      rechargesData: {},
      unit: -1,
      msgError: undefined

    }
  },
  computed: {
    contractId: function () {
      return this.$route.params.contractId;
    },
    contract() {
      return this.$store.getters.getContractById(this.contractId);
    },
    planId: function(){
     return this.$route.params.planId;
    },
    valueFormatted: function () {
      this.$nextTick(()=>{
        //para o cursor continuar no final do input
        $('#valueTotal').val($('#valueTotal').val());
      });
      return cents(this.rechargeValue).replace('R$', '');

    },
    total: function () {
      if (this.rate)
        return cents(this.rate.valueTotal + this.rate.taxTotal);
      else
        return cents(0);
    },
    tax: function () {
      if (this.rate)
        return cents(this.rate.taxTotal);
      else
        return cents(0);
    }
  },
  created() {
    this.source = axios.CancelToken.source();
    this.minValue = this.contract.rechargeValue;
  },
  watch:{
    unit(newValue) {
      this.msgError = undefined;
      if(newValue == -1)
        this.$nextTick(()=>{$('#valueTotal').focus();});
    },
  },
  mounted() {
  },
  methods: {

    setTotal: function (newValue) {
      this.msgError = undefined;
      this.rechargeValue = newValue.replace(/[^0-9]/g, '');
      this.calculateRecharge();
    },
    getQuantity: function () {
      return 1;
    },
    calculateRecharge: function () {
      if (!validaRecarga.validate(this.rechargeValue, [this.minValue])) {
        this.rate = 'N/A';
        return false;
      }
      this.source.cancel('cancelada');
      this.source = axios.CancelToken.source();
      this.waiting = true;
      let promise = sales.calculateRechargeRate({ cancelToken: this.source.token, value: this.rechargeValue, planId:  this.planId, contractId: this.contractId})
        .then(resp => {
          this.rate = resp.taxTotal;
          this.credit = resp.valueTotal;
          this.waiting = false;
        }).catch(err => {
          this.waiting = false;
          this.rate = 'N/A';
          this.credit = 0;
        });
      this.$store.dispatch('loading', promise);
    },
    getSalesOrder() {
        this.msgError = undefined;
        if(this.unit == -1 && (!this.rechargeValue || parseInt(this.rechargeValue) <= parseInt(this.minValue))){
          this.msgError = `Valor de recarga inválido`;
          return false;
        }
          let v = 0;
          if(this.unit == -1)
            v = this.rechargeValue;
          else
            v = this.unit;



          let salesOrder = {
            account: {moveMaisId: this.moveMaisId},
            type: "RECHARGE",
            salesType: "RECHARGE",
            _interface: window.document.webview ? "MOBILE" : "WEBSITE",
            contract: this.contractId,
            price: parseInt(v) + parseInt(this.rate),
            value: parseInt(v),
            products: [
              {
                productId: 2,
                productName: "RECARGA",
                quantity: 1,
                valueTotal: v,
                valueUnit: v
              },
              {
                productId: 3,
                productName: "TAXA DE RECARGA",
                quantity: 1,
                valueTotal: this.rate,
                valueUnit: this.rate
              }
            ]
          };

          return Promise.resolve(salesOrder);




    }


  },

  components: {
  }
}



// WEBPACK FOOTER //
// ./src/pages/account/recharge/recharge-tax.js